/*
 * @Author: liujunhong
 * @Date: 2023/7/6
 * @Desc: 认证绑定手机相关
 */


import { post } from '@/utils/request';
import { MAP_SITE_URL } from '@/constants';

const {API_SECURITY_URL} = MAP_SITE_URL;

/**
 * wegame校验旧手机号
 */
interface ValidPhone {
  phone?: string;
  verifyCode?: string;
}

export const checkOldPhone = (params: ValidPhone) => {
  return post(`${API_SECURITY_URL}/v1/security/account/wegame/checkOldPhone`, params);
};

export const changeNewPhone = (params: ValidPhone) => {
  return post(`${API_SECURITY_URL}/v1/security/account/wegame/changeNewPhone`, params);
};